import React, { useEffect, useState } from "react";
//@ts-ignore
import style from "./DocumentForm.module.css";
import SelectInput from "@Atoms/inputs/selectInput/SelectInput";
import TextInput from "@Atoms/inputs/textInput/TextInput";
import CircularInput from "@Atoms/inputs/CircularInput/CircularInput";
import CustomSelect from "@Molecules/InputPhoneNumber/CustomSelect";
import CheckboxInput from "@Atoms/inputs/checkboxInput/CheckboxInput";
import ValidationInput from "@Atoms/inputs/validationInput/ValidationInput";
import {
  CARNET_DE_EXTRANJERIA,
  DNI,
  FEMENINO,
  MASCULINO,
  OTRO,
  PASAPORTE,
  typeDocuments,
} from "../constants/constants";
import {
  calculateAge,
  handleInputChange,
  isEmailValid,
  isValidDate,
  sanitizeAndSetForm,
} from "../FormFunctions/FormFunctions";
import DateInput from "@Atoms/inputs/dateInput/DateInput";
import { TimesIcon } from "@Models/icons";
import { DEFAULT_PHONE_COUNTRY_CODE } from "@Models/phoneCountryCodes";
// @ts-ignore
import { Icon } from "@viuti/recursos";
import { sanitizePersonName } from "@/utils/strings/sanitizePersonName";

const DocumentForm = ({
  form,
  setForm,
  status,
  edit,
  isLoading,
  categories,
  searchingInReniec,
}) => {
  const [propsDocumentNumber, setPropsDocumentNumber] = React.useState({
    label: "Número de documento",
    name: "documentNumber",
    value: form.documentNumber,
    handleChange: (e) => {},
    placeholder: "Número de documento",
    maxLength: 8,
    width: "100%",
    status,
    disabled: isLoading || searchingInReniec,
  });
  const [checked, setChecked] = React.useState(form.sex);

  useEffect(() => {
    setPropsDocumentNumber({
      ...propsDocumentNumber,
      disabled: isLoading || searchingInReniec,
    });
  }, [isLoading, searchingInReniec]);

  useEffect(() => {
    setChecked(form.sex);
  }, [form.sex]);

  const [phoneValues, setPhoneValues] = React.useState({
    codeCountryPhone: form.codeCountryPhone || DEFAULT_PHONE_COUNTRY_CODE,
    phoneNumber: form.phoneNumber,
  });

  useEffect(() => {
    setForm((prev) => ({
      ...prev,
      sex: checked,
    }));
  }, [checked]);

  useEffect(() => {
    setPropsDocumentNumber({
      ...propsDocumentNumber,
      status,
    });
  }, [status]);

  const setDocumentNumberProps = (label, placeholder, maxLength) => {
    setPropsDocumentNumber({
      ...propsDocumentNumber,
      label: label,
      name: "documentNumber",
      value: form.documentNumber,
      handleChange: (e) =>
        sanitizeAndSetForm(e, maxLength, setForm, form, label),
      placeholder: placeholder,
      maxLength: maxLength,
      width: "100%",
      status: status,
      disabled: isLoading || searchingInReniec,
    });
  };

  useEffect(() => {
    switch (form.documentType) {
      case DNI:
        setDocumentNumberProps("Número de documento", "Número de documento", 8);
        break;
      case PASAPORTE:
        setDocumentNumberProps(
          "Número de pasaporte",
          "Número de pasaporte",
          30
        );
        break;
      case CARNET_DE_EXTRANJERIA:
        setDocumentNumberProps(
          "Número de carnet",
          "Número de carnet de extranjería",
          12
        );
        break;
      default:
    }
  }, [form.documentType, form.documentNumber]);

  const handleCheck = (e, sex) => {
    e.preventDefault();
    // if (edit) return;
    setChecked(sex);
  };

  useEffect(() => {
    // Funcional a propósito: la casilla de "no desea brindar su teléfono"
    // escribe en el mismo objeto y con la forma literal se pisaban entre sí.
    setForm((prev) => ({
      ...prev,
      codeCountryPhone: phoneValues.codeCountryPhone,
      phoneNumber: phoneValues.phoneNumber,
    }));
  }, [phoneValues]);

  const handlePhoneRefusedChange = (isRefused) => {
    if (isRefused) setPhoneValues({ ...phoneValues, phoneNumber: "" });
    setForm((prev) => ({
      ...prev,
      phoneRefused: isRefused,
      ...(isRefused ? { phoneNumber: "" } : {}),
    }));
  };

  const [localError, setLocalError] = useState("");

  const handleInputChanges = (e) => {
    const { name, value } = e.target;
    let errorMessage = "";

    if (name === "birthdate") {
      const isValid = isValidDate(value);
      if (!isValid) {
        errorMessage = "La fecha de nacimiento no es válida.";
      }
    }
    setLocalError(errorMessage);
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <section className={style.containerInputs}>
      <article>
        <div>
          <SelectInput
            label={"Tipo de documento"}
            name={"documentType"}
            flex={1}
            value={form.documentType}
            touched={false}
            error={false}
            handleChange={(e) =>
              setForm({ ...form, documentType: e.target.value })
            }
            handleBlur={() => {}}
            items={typeDocuments}
            placeholder={"Tipo de documento"}
            width="100%"
            disabled={isLoading || searchingInReniec}
          />
        </div>
        <div data-testid="client-document">
          <ValidationInput
            {...propsDocumentNumber}
            // El valor sale del form y no de propsDocumentNumber, que se
            // refresca un render tarde y hacía perder teclas al escribir.
            value={form.documentNumber}
            status={
              form.documentType === CARNET_DE_EXTRANJERIA &&
              form.documentNumber &&
              form.documentNumber.length < 8
                ? {
                    ...propsDocumentNumber.status,
                    error: true,
                    validated: false,
                    message:
                      "El carné de extranjería debe tener entre 8 y 12 caracteres",
                  }
                : propsDocumentNumber.status
            }
          />
        </div>
      </article>
      <article>
        <div data-testid="client-name">
          <TextInput
            label={"Nombre"}
            name={"name"}
            value={form.name}
            touched={false}
            error={false}
            handleChange={(e) => {
              const { name, value } = e.target;
              const sanitizedValue = sanitizePersonName(value);
              setForm((prev) => ({ ...prev, [name]: sanitizedValue }));
            }}
            placeholder={"Nombre"}
            disabled={isLoading || searchingInReniec}
            keyboardType="text"
            required={true}
            maxLength={50}
            width="100%"
          />
        </div>
        <div data-testid="client-lastname">
          <TextInput
            label={"Apellido"}
            name={"lastName"}
            value={form.lastName}
            touched={false}
            error={false}
            handleChange={(e) => {
              const { name, value } = e.target;
              const sanitizedValue = sanitizePersonName(value);
              setForm((prev) => ({ ...prev, [name]: sanitizedValue }));
            }}
            placeholder={"Apellido"}
            disabled={isLoading || searchingInReniec}
            keyboardType="text"
            required={true}
            maxLength={50}
            width="100%"
          />
        </div>
      </article>

      <article>
        <div data-testid="client-birthday">
          <DateInput
            label={"Fecha de nacimiento"}
            touched={true}
            error={localError}
            disabled={isLoading || searchingInReniec}
            required={false}
            containerStyle={{ width: "100%" }}
            inputStyle={{ width: "100%" }}
            inputProps={{
              value: form.birthdate,
              onChange: handleInputChanges,
              name: "birthdate",
            }}
          />
        </div>
        <div className={style.countrySelectContainer} data-testid="client-phone">
          <label htmlFor="number">
            Teléfono móvil
            {!form.phoneRefused && <span className={style.requiredMark}>*</span>}
          </label>
          <CustomSelect
            phoneValues={{
              codeCountryPhone: phoneValues.codeCountryPhone,
              phoneNumber: phoneValues.phoneNumber,
            }}
            setPhoneValues={setPhoneValues}
            handleInputChange={(e) =>
              handleInputChange(e, phoneValues, setPhoneValues)
            }
            placeholder="Número de teléfono"
            isDisabled={
              isLoading || searchingInReniec || form.phoneRefused === true
            }
          />
          <div className={style.phoneRefusedRow} data-testid="client-phone-refused">
            <CheckboxInput
              label="El cliente no desea brindar su teléfono"
              touched={false}
              error={""}
              disabled={isLoading || searchingInReniec}
              required={false}
              hoverOn={true}
              inputProps={{
                checked: form.phoneRefused === true,
                onChange: (e) => handlePhoneRefusedChange(e.target.checked),
                disabled: isLoading || searchingInReniec,
              }}
            />
          </div>
        </div>
      </article>
      <article>
        <div className={style.containerSelectCategory}>
          <SelectInput
            label={"Categoría de cliente"}
            name={"categoryClientId"}
            flex={1}
            value={form.categoryClientId}
            touched={false}
            error={false}
            handleChange={(e) =>
              setForm({ ...form, categoryClientId: e.target.value })
            }
            items={categories}
            placeholder={"Selecciona una categoría"}
            width="100%"
            disabled={isLoading || searchingInReniec}
          />
          <span className={style.containerClearCategory}>
            {form.categoryClientId && (
              <button
                className={style.buttonClearCategory}
                disabled={isLoading || searchingInReniec}
                title="Limpiar categoría"
                onClick={() => {
                  setForm({
                    ...form,
                    categoryClientId: "",
                  });
                }}
                type="button"
              >
                <Icon path={TimesIcon} color={"#ACACAC"} size={15} />
              </button>
            )}
          </span>
        </div>
      </article>
      <article data-testid="client-email">
        <TextInput
          label={"Correo electrónico"}
          name={"email"}
          value={form.email}
          touched={form.email !== ""}
          error={
            form.email && !isEmailValid(form.email)
              ? "No es un correo válido."
              : ""
          }
          handleChange={(e) => {
            const { name, value } = e.target;
            setForm({ ...form, [name]: value });
          }}
          placeholder={"Correo electrónico"}
          disabled={isLoading || searchingInReniec}
          keyboardType="text"
          maxLength={8}
          inputProps={{
            type: "email",
          }}
        />
      </article>
      <article className={style.containerSex} data-testid="client-gender">
        <label className={style.inputLabel}>
          <p>Sexo</p>
        </label>
        <div className={style.containerButtonsSex}>
          <button
            onClick={(e) => handleCheck(e, FEMENINO)}
            style={{
              cursor: isLoading || searchingInReniec ? "default" : "pointer",
            }}
          >
            <span>Femenino</span>
            <CircularInput
              checked={checked === FEMENINO}
              id={FEMENINO}
              onClick={(e) => handleCheck(e, FEMENINO)}
              locked={isLoading || searchingInReniec}
            />
          </button>
          <button
            onClick={(e) => handleCheck(e, MASCULINO)}
            style={{
              cursor: isLoading || searchingInReniec ? "default" : "pointer",
            }}
          >
            <span>Masculino</span>
            <CircularInput
              checked={checked === MASCULINO}
              id={MASCULINO}
              onClick={(e) => handleCheck(e, MASCULINO)}
              locked={isLoading || searchingInReniec}
            />
          </button>
          <button
            onClick={(e) => handleCheck(e, OTRO)}
            style={{
              cursor: isLoading || searchingInReniec ? "default" : "pointer",
            }}
          >
            <span>Otro</span>
            <CircularInput
              checked={checked === OTRO}
              id={OTRO}
              onClick={(e) => handleCheck(e, OTRO)}
              locked={isLoading || searchingInReniec}
            />
          </button>
        </div>
      </article>
    </section>
  );
};

export default DocumentForm;
